import React, { Fragment } from 'react';
import { shortenAddress } from '@sc1/common/utils';
import { useWeb3React, useToastError } from '@sc1/common/hooks';
import { Button } from './core';
import { connector } from '@sc1/common/utils/connectors';

export const ConnectWallet = (): JSX.Element => {
  const { account, activate, deactivate, error } = useWeb3React();
  useToastError(error, error?.message || 'Error connecting to wallet');
  return (
    <Fragment>
      <Button
        variant="round"
        sx={{ width: 180 }}
        onClick={() => {
          account ? deactivate() : activate(connector);
        }}
      >
        {account ? shortenAddress(account) : 'Connect Wallet'}
      </Button>
    </Fragment>
  );
};
